module.exports = __webpack_public_path__ + "img/PR14.7160300f.png";